// extracted by mini-css-extract-plugin
export default {"textStyle":"aboutUs_textStyle__Pg6te"};